const RenderNotConnectedContainer = ({
  currentAccount,
  setCurrentAccount,
  connectWallet,
}) => {
  return (
    <div className="connect-wallet-container">
      <img
        src="https://media.giphy.com/media/gHERHZMwbEt4k9VXlF/giphy.gif"
        alt="Bird gif"
      />
      <button
        onClick={() => connectWallet()}
        className="cta-button connect-wallet-button"
      >
        Connect Wallet
      </button>
    </div>
  );
};

export default RenderNotConnectedContainer;
